import { Destructable } from "./lib/types";
import { addDependency } from "./lib/utils";
import DestructableObject from "./lib/DestructableObject";

export function addChild(parent: Destructable, child: Destructable = new DestructableObject()): Destructable {
	if (parent instanceof DestructableObject) {
		parent.addChild(child);
	} else {
		addDependency(child, parent, () => child.destroy());
	}
	return child;
}

export { DestructionObserver, Destructable, Subscription } from "./lib/types";
export { default as DestructableObject } from "./lib/DestructableObject";
export { default as DestructableMap } from "./lib/DestructableMap";
export { default as DestructableSet } from "./lib/DestructableSet";
export { default as DestructorSet } from "./lib/DestructorSet";
export { default as DestructorMap } from "./lib/DestructorMap";
export { default as OnDemandEvaluatedMap } from "./lib/OnDemandEvaluatedMap";
export { default as SubscriptionMap } from "./lib/SubscriptionMap";
export { default as DestructorPool } from "./lib/DestructorPool";
export { isDestructable, addDependency } from "./lib/utils";
